module.exports = __webpack_public_path__ + "img/heart-null-black.8de2563d.svg";